export const CLOUDINARY_DOMAIN_ACCOUNT = 'https://res.cloudinary.com/dalvopawo/image/upload';